/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type PassthruType = (typeof PassthruType)[keyof typeof PassthruType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PassthruType = {
    Unknown: 'Unknown',
    Domestic: 'Domestic',
    Partnership: 'Partnership',
    SCorporation: 'SCorporation',
} as const;
